<script>
    let openItems = {};

    function toggle(i) {
        openItems[i] = !openItems[i];
        openItems = openItems;
    }

    const faqs = [
        {
            question: "How does SmartClaim work?",
            answer: "SmartClaim employs the most advanced generative AI models, expertly configured with built-in knowledge of R&D tax relief guidelines (DSIT, GfC3, CIRD).",
        },
        {
            question: "Is it just like ChatGPT or Claude?",
            answer: "No, ChatGPT and Claude are for general-purpose use, whereas SmartClaim is specifically built for R&D consultants. This enables SmartClaim to significantly outperform general-purpose AI in R&D narratives.",
        },
        {
            question: "Is it ethical to use AI?",
            answer: "Yes, provided that the input information is accurate and not fabricated, and that human judgement is applied in assessing project eligibility. SmartClaim AI relies solely on the information supplied; it does not introduce additional details or enhance a project's qualifications beyond what is genuinely justified. It functions in the same way as engaging a colleague to draft the narrative. Responsible AI use is about leveraging its strengths while ensuring human oversight. AI is a powerful tool - not a replacement for human expertise, but a complement that amplifies it. The newfound efficiency from AI not only enhances the quality of the work, but also frees up valuable time for consultants to engage more deeply with their clients - the part of the job that's truly rewarding.",
        },
        {
            question: "Is it safe and secure?",
            answer: "Absolutely! SmartClaim is built on enterprise-grade security infrastructure - Microsoft Azure and AWS, both SOC2 and ISO-27001 certified. SmartClaim also does not store user data; once a task is completed, the data is erased. User data is never used for AI training.",
        },
        {
            question: "Can we try it first?",
            answer: "Absolutely. We recommend teams and enterprises to start with a controlled pilot — typically one-month with a small group of R&D consultants.",
        },
        {
            question: "Is it compliant with HMRC's January 2026 guidance on the use of generative AI in tax software?",
            answerHtml: `<p class="pt-4">Absolutely.</p>
<ul class="pt-3 space-y-2 list-none">
  <li>Transparency: Clear indication of AI being used.</li>
  <li>Reliable, HMRC-aligned sources: Grounded in HMRC guidance (DSIT &amp; GfC3).</li>
  <li>Human oversight and control: The user experience is designed to support professional judgement, with built-in checks (including source referencing and hallucination checks) and outputs structured to make review, challenge, and refinement straightforward.</li>
  <li>Data security and privacy: Enterprise-grade secure infrastructure; user data never used to train AI models.</li>
  <li>Ethical use: Designed to support robust, compliant R&D tax relief claim submissions.</li>
</ul>
<p class="pt-3">We're more than happy to walk through this in more detail.</p>`,
        },
    ];
</script>

<div class="max-w-3xl mx-auto px-6 md:px-16">
    <h2 class="text-[38px] font-semibold text-navy text-center mb-12">Frequently asked questions</h2>
    <div class="space-y-3">
        {#each faqs as faq, i}
            <div class="bg-white border border-card-border rounded-xl overflow-hidden shadow-sm">
                <button
                    class="w-full flex items-center justify-between px-6 py-5 text-left hover:bg-gray-50 transition"
                    on:click={() => toggle(i)}
                >
                    <span class="font-semibold text-navy">{faq.question}</span>
                    <svg
                        class="w-5 h-5 text-gray-400 flex-shrink-0 transition-transform {openItems[i] ? 'rotate-180' : ''}"
                        fill="none" viewBox="0 0 24 24" stroke="currentColor"
                    >
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                    </svg>
                </button>
                {#if openItems[i]}
                    <div class="px-6 pb-5 text-sm text-gray-600 leading-relaxed border-t border-gray-100">
                        {#if faq.answerHtml}
                            {@html faq.answerHtml}
                        {:else}
                            <p class="pt-4">{faq.answer}</p>
                        {/if}
                    </div>
                {/if}
            </div>
        {/each}
    </div>
</div>
